export default __webpack_public_path__ + "static/romeo-7e94634acc7ca85a3f5bc7a2fb84c101.jpg";